import { render, staticRenderFns } from "./StringFormatter.Truncate.vue?vue&type=template&id=65d9e882&scoped=true"
import script from "./StringFormatter.Truncate.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Truncate.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Truncate.vue?vue&type=style&index=0&id=65d9e882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9e882",
  null
  
)

export default component.exports